import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    checkboxRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    buttonsContainer: {
        flexDirection: "row"
    },
    modalContent: {
        maxWidth: "90%",
        zIndex: 999999,
        width: 500
    },
    permissionsScroll: {
        maxHeight: 200
    },
    permissionsTitle: {
    },
    formContainer: {
    }
});
export default stylesheet;
